import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import { ActionButtonsStyle, ProductsListSettingsFormStyle } from './css/ProductsListSettingsFormStyle'

function RecordsPerPageForm(props) {
  const { rpp, setRpp } = props

  return (
    <React.Fragment>
      <div id='rpp' className='form-container'>
        <h4 className='header-caption'>Records/Page</h4>
        <div className='settings-input-form'>
          <input
            id='rec-pp'
            className='top-anchor'
            type='number'
            min='1'
            value={rpp || ''}
            onChange={ (e) => (e.target.value) ? setRpp(parseInt(e.target.value)) : setRpp('') }
          />
        </div>
      </div>
    </React.Fragment>
  )
}

function WarehouseForm(props) {
  const { warehouses, warehouse, setWarehouse } = props

  return (
    <React.Fragment>
      <div id='warehouses' className='form-container'>
        <h4 className='header-caption'>Warehouse</h4>
        <div className='settings-input-form'>
          <select
            id='warehouse'
            name='warehouse'
            value={warehouse?.name}
            onChange={(e) => {
              setWarehouse({
                ...warehouse,
                name: e.target.value,
                id: warehouses?.find(wh => wh.name === e.target.value)._id
              })
            }}>
            {
              (warehouses) ?
                warehouses.map(wh => (
                  <option key={wh._id} style={{fontSize: '1rem'}}>{wh.name}</option>
                ))
              : null
            }
          </select>
        </div>
      </div>
    </React.Fragment>
  )
}

function ActionButtons({ warehouse, rpp, updateSettings }) {
  return (
    <React.Fragment>
      <div id='buttons' className='form-container'>
        <div id='action-button-container'>
          <button
            onClick={(e) => {
              updateSettings({record_per_page: parseInt(rpp), warehouse_id: warehouse.id})
              ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
            }}
            className='pospro-action-btn'>
            Apply
          </button>
          <button
            onClick={(e) => {
              ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
            }}
            className='pospro-action-btn bottom-anchor'>
            Close
          </button>
        </div>
      </div>
      <ActionButtonsStyle />
    </React.Fragment>
  )
}

function ProductsListSettingsForm(props) {
  const { app, updateSettings, getProductsListSettings, getWarehouses } = props
  const [warehouses, setWarheouses] = useState(null)
  const [warehouse, setWarehouse] = useState(null)
  const [rpp, setRpp] = useState(null)

  const recordPerPageFormProps = { rpp, setRpp }
  const warehouseFormProps = { warehouses, warehouse, setWarehouse }
  const actionButtonsProps = { warehouse, rpp, updateSettings }

  useEffect(() => {
    const init = async () => {
      const warehouses = await getWarehouses(app)
      setWarheouses(warehouses)
      const products_list_settings = await getProductsListSettings(app)
      setRpp(products_list_settings.record_per_page)

      const settings_warehouse = warehouses.find(wh => wh._id === products_list_settings.warehouse_id)

      if (settings_warehouse) setWarehouse({name: settings_warehouse.name, id: settings_warehouse._id})

      document.getElementById('rec-pp').focus()
    }

    init()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <React.Fragment>
      <div className='main-wrapper'>
        <div className='main-container'>
          <RecordsPerPageForm { ...recordPerPageFormProps } />
          <WarehouseForm { ...warehouseFormProps } />
        </div>
        <ActionButtons { ...actionButtonsProps } />
        <ProductsListSettingsFormStyle />
      </div>
    </React.Fragment>
  )
}

export default React.memo(ProductsListSettingsForm)